module.exports = __webpack_public_path__ + "static/media/schody14 - schody drewniane zabiegowe nakladane.18d1d620.jpg";